<main @fade>
  <div>
    <ng-select
      [items]="damItemsSelect"
      bindLabel="header"
      bindValue="id"
      [minTermLength]="2"
      [clearable]="false"
      (change)="changeSelected($event)"
      [(ngModel)]="selectedDamItemID"
      typeToSearchText="Пожалуйста, введите 2 или более символов"
      i18n-typeToSearchText="@@TemplateAutocompleteTypeToSearchText"
      placeholder="Выберите освновной элемент"
      i18n-placeholder="@@TemplateAutocompleteLabel"
    />

    <div>Объединение элементов объединит все вложения и тэги</div>
    <div><strong>Всего вложений: {{ countAllDamVersion }} шт.</strong></div>


    <nb-card-footer>
      <button (click)="unitItems()" nbButton type="button">Объединить</button>
    </nb-card-footer>
  </div>
</main>
